import moment from 'moment'
import loggingService from './loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'dateService'
var isDebug = false

var standardDateFormat = 'YYYY-MM-DD'
var standardDateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
var standardTimeFormat = 'HH:mm:ss'

function convertToDate (value) {
    if (!value) {
        loggingService.log(isDebug, serviceName, 'convertToDate(' + value + ' -> null)')
        return null
    }

    if (value === '') {
        loggingService.log(isDebug, serviceName, 'convertToDate(' + value + ' -> null)')
        return null
    }

    var result = moment(value)
    loggingService.log(isDebug, serviceName, 'convertToDate(' + value + ' -> ' + result + ')')
    return result
}

function convertToDateString (value) {
    var momentResult = convertToDate(value)
    return momentResult ? momentResult.format(standardDateFormat) : ''
}

function convertToDateTimeString (value) {
    var momentResult = convertToDate(value)
    return momentResult ? momentResult.format(standardDateTimeFormat) : ''
}

function convertToTimeString (value) {
    var momentResult = convertToDate(value)
    return momentResult ? momentResult.format(standardTimeFormat) : ''
}

function toDateTimeString (value) {
    //This requires a json date format
    return moment(String(value), moment.ISO_8601).format(standardDateTimeFormat)
}

function toStringNow () {
    //This requires a json date format
    return fromMomentToDateTimeString(moment())
}

function fromMomentToDateTimeString (value) {
    return value.format(standardDateTimeFormat)
}

function convertListWithModifiedDates (list) {
    _.forEach(list, function (value, key) {
        value.createdDate = convertToDate(value.createdDate)
        value.modifiedDate = convertToDate(value.modifiedDate)
    })
}

function getDurationHumanized (startDate, endDate = moment()) {
    return moment.duration(endDate.diff(startDate)).humanize()
}

function dateTimeStringToMoment (date, time) {
    if (!date || date === '') {
        return null
    }
    if (!time || time === '') {
        return moment(date, moment.ISO_8601).format(standardDateTimeFormat)
    } else {
        return moment(date + 'T' + time, moment.ISO_8601).format(standardDateTimeFormat)
    }
}

function parseDateTimeToIndivStrings (obj) {
    _.forEach(obj, function (value, key) {
        if (typeof key === 'string' && key.endsWith('Date')) {
            var dateStringKey = key + 'String'
            obj[dateStringKey] = convertToDateString(value)
            var timeStringKey = key.slice(0, -4) + 'TimeString'
            obj[timeStringKey] = convertToTimeString(value)
        }
    })
}

export default {
    convertToDate: convertToDate,
    toDateTimeString: toDateTimeString,
    fromMomentToDateTimeString: fromMomentToDateTimeString,
    toStringNow: toStringNow,
    convertListWithModifiedDates: convertListWithModifiedDates,
    getDurationHumanized: getDurationHumanized,
    convertToDateString: convertToDateString,
    convertToDateTimeString: convertToDateTimeString,
    convertToTimeString: convertToTimeString,
    dateTimeStringToMoment: dateTimeStringToMoment,
    parseDateTimeToIndivStrings: parseDateTimeToIndivStrings
}
